<template>
  <div class="ota-faq-container">
    <div v-for="(item, index) in items" :key="item.title" class="faq border-gray-100 border-2 mb-3">
      <div
        class="faq-body w-full px-5 py-4 text-md text-gray-600 font-semibold flex justify-between items-center cursor-pointer ring-offset-2 ring-2 ring-transparent focus:ring-primary"
        :aria-expanded="isOpen(index)"
        :aria-label="`${isOpen(index) ? 'Open' : 'Close'} ${item.title}`"
        tabindex="0"
        role="button"
        @click="openItem(index)"
        @keydown.enter.prevent="openItem(index)"
        @keydown.space.prevent="openItem(index)"
      >
        <div class="ota-body font-bold pr-3 text-left" v-html="item.title" />
        <div>
          <div v-show="isOpen(index)">
            <OSvg class="w-3" svg="min" />
          </div>
          <div v-show="!isOpen(index)">
            <OSvg class="w-3 fill-neutral-400" svg="plus" />
          </div>
        </div>
      </div>
      <div v-show="currentOpenItem === index" class="faq-description o-body text-gray-600 px-5 py-4 pt-0" v-html="item.description" />
    </div>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export default {
  name: 'Faq',
  components: { OSvg },
  props: {
    items: {
      type: Array,
      default: () => ([])
    },
    initialOpenIndex: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      currentOpenItem: this.initialOpenIndex
    }
  },
  methods: {
    openItem (index) {
      this.isOpen(index) ? this.currentOpenItem = null : this.currentOpenItem = index
    },
    isOpen (index) {
      return this.currentOpenItem === index
    }
  }
}
</script>
<style lang="postcss" scoped>
.faq {
  border-radius: 1rem;

  .montserrat-currency, >>> .montserrat-currency {
    @apply font-body;
  }

  >>> a, >>> button {
    @apply underline italic text-newBlue-400 cursor-pointer;
  }
}
</style>
